import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getCopResolutionsByGroup = api(async function copResolutionsByGroup({ codeOfPracticeId }) {
    return query(
        gql`
            query GetCopResolutionsByGroup($codeOfPracticeId: ID!) {
                copResolutionsByGroup(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "copResolutionsByGroup" }
    )
})
